import React, { Component } from 'react';
import Helmet from 'react-helmet';
import map from 'lodash/map';

import { css } from 'glamor';
import typography from '../utils/typography';

import Image from '../components/Image';
import WorkNav from '../components/WorkNav';
import Loader from '../components/Loader';
import Animated from '../components/Animated';

import {
  wrapper,
  textContainer,
  fullWidth,
  // halfWidth,
  thirdWidth,
} from '../styles';

const row1 = (image, index) => {
  return (
    <div {...fullWidth} key={`image-${index}`}>
      <Image sources={image} />
    </div>
  );
};

// const row2 = (image, index) => {
//   return (
//     <div {...halfWidth} key={`image-${index}`}>
//       <Image sources={image} />
//     </div>
//   );
// };

const row3 = (image, index) => {
  return (
    <div {...thirdWidth} key={`image-${index}`}>
      <Image sources={image} />
    </div>
  );
};

class Sketches extends Component {
  componentWillMount() {
    this.props.load();
  }

  render() {
    const { content } = this.props;
    if (!content) {
      return <Loader />;
    }

    const {
      prev,
      next,
      content: { images },
    } = this.props;

    return (
      <div>
        <Helmet
          title="Sketches by lucastswick"
          description="Unfinished explorations that nobody likes except me."
          meta={[
            {
              property: 'og:image:url',
              content: `https://generativeartist.com${images[0][2].srcSet}`,
            },
            {
              property: 'twitter:image',
              content: `https://generativeartist.com${images[0][2].srcSet}`,
            },
          ]}
        />
        <div {...textContainer}>
          <Animated as="h1">Sketches</Animated>
          <Animated delay={150}>
            My process embraces the unexpected. The generated results are often
            slight distortions of my desired outcome, but surprise and
            astonishment are what keep me engaged.
          </Animated>
          <Animated delay={300}>
            Each of these pieces is the result of going down a path that took me
            far from my original intent. Perhaps one day I'll explore these
            ideas in more depth and they'll become their own series.
          </Animated>
        </div>
        <div {...wrapper} {...css({ marginBottom: typography.rhythm(2) })}>
          {map(images, (image, index) => {
            if (index % 4 === 0) {
              return row1(image, index);
            } else {
              return row3(image, index);
            }
          })}
        </div>
        <WorkNav prev={prev} next={next} />
      </div>
    );
  }
}

export default Sketches;



// WEBPACK FOOTER //
// ./src/pages/Sketches.js